import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import {
    ComposedModal,
    Button,
    InlineLoading,
    Loading,
    ModalHeader,
    ModalBody,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableHeader,
    TableCell,
    Tile,
  } from 'carbon-components-react';
import View16 from '@carbon/icons-react/lib/view/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import FileUpload from '../common/FileUpload';
import DownLoadButton from '../common/FileDownloadButton';
import { api } from '../../helpers/api/api';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { Online, Offline } from '../common/OnLineOffLine';
import { getError, apioperation, entitiesLabels, sizeFormat } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';

const EDrillWorkSiteAttachmentModal = ({ onCloseWorkSiteAttachmentModal, 
    selectedWorksite, 
    showWorkSiteAttachmentModal,
    initialWorksiteAttachment }) => {
    const [modalDeleteAttachmentVisible, setModalDeleteAttachmentVisible] = useState(false);
    const [selectedDeleteAttachment, setSelectedDeleteAttachment] = useState(null);
    const [downloadingItemId, setDownlodingItemId] = useState(null);
    const [worksiteAttachments, setWorksiteAttachements] = 
      useState(initialWorksiteAttachment || []);
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => (setWorksiteAttachements(initialWorksiteAttachment)), 
              [initialWorksiteAttachment]);
    

    const onUpload = async (fileIdentifier, fileName, fileType, size) => {
      const newAttach = {
        id: uuid(),
        fileIdentifier: fileIdentifier.blobName,
        name: fileName,
        contentType: fileType,
        size,
      };
      try {
        setSubmitted(true);
        await api.post(`/drill/${selectedWorksite.id}/drillplanbyworksiteattachment`, newAttach);
        setWorksiteAttachements(
          [...worksiteAttachments, 
            {
              idAttachment: newAttach.id,
              idWorkSite: selectedWorksite.id,
              attachment: newAttach,
            }
          ]
        );
          // DrillRepository.updateCachedDrill(drillReport);
        return `${entitiesLabels.SUCCESS}`;
      } catch (error) {
        return showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EMERGENCYDRILL_WORKSITEATTACHMENT, apioperation.POST)
        );
      } finally {
        setSubmitted(false);
      }
    };

    /* **************** DELETE ATTACHMENT START **************** */
    const onDelete = async (id) => {
      const index = worksiteAttachments.findIndex((a) => a.idAttachment === id);
      try {
        setSubmitted(true);
        await api.deleteData(
          `/drill/${selectedWorksite.id}/drillplanbyworksiteattachment/${worksiteAttachments[index].attachment.fileIdentifier}`
        );
        setWorksiteAttachements(worksiteAttachments.filter(
          (a) => a.idAttachment !== worksiteAttachments[index].idAttachment
        ));
        return `${entitiesLabels.SUCCESS}`;
      } catch (error) {
        return showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.FileUpload, apioperation.DELETE)
        );
      } finally {
        setSubmitted(false);
      }
    };

    const handleDeleteAttachmentModalVisibility = () => {
        setModalDeleteAttachmentVisible(!modalDeleteAttachmentVisible);
        setSelectedDeleteAttachment(null);
    };
    
    const showDeleteAttachmentModal = (Id) => {
        const selectedItem = worksiteAttachments.find((item) => item.idAttachment === Id);
        setSelectedDeleteAttachment(selectedItem);
        setModalDeleteAttachmentVisible(!modalDeleteAttachmentVisible); 
    };
    
    const deleteAttachment = () => {
        onDelete(selectedDeleteAttachment.idAttachment);
        handleDeleteAttachmentModalVisibility();
    };
    
    const renderDeleteAttachmentModal = () => modalDeleteAttachmentVisible && (
    <div className="bx--modal bx--modal-tall is-visible">
      <div className="bx--modal-container">
        <div className="bx--modal-header">
          <h3 className="bx--modal-header__heading">Delete Attachment</h3>
          <Button
            className="bx--modal-close"
            renderIcon={Close16}
            onClick={() => handleDeleteAttachmentModalVisibility()}
          />
        </div>
    
        <div className="bx--modal-content">
          <div className="bx--row bx--modal-content-detail">
            <div className="bx--col-lg-12 bx--col-md-12">
              <h5 className="align-center">
                {`Press confirm to delete ${selectedDeleteAttachment?.attachment.name}`}
              </h5>
            </div>
          </div>
        </div>
        <div className="bx--modal-footer">
          <Button
            className="button--max-width"
            kind="secondary"
            onClick={() => handleDeleteAttachmentModalVisibility()}
          >
            Cancel
          </Button>
          <Button 
            className="button--max-width" 
            kind="primary" 
            onClick={() => deleteAttachment()}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
    );
    /* **************** DELETE ATTACHMENT END ****************** */
    const renderLoading = () => {
      const show = submitted;
      return show && <Loading active withOverlay description="Saving..." />;
    };

    return (
      
      <ComposedModal
        className="light-modal box-medium-modal"
        open={showWorkSiteAttachmentModal}
        danger="false"
        onClose={() => false}
      >
        {renderLoading()}
        <ModalHeader
          className="margin-modal"
          title="Annual drill Plan document - Worksite"
          iconDescription="Close"
          buttonOnClick={onCloseWorkSiteAttachmentModal}
        />

        <ModalBody className="margin-modal">
          <div>
            {renderDeleteAttachmentModal()}
            <Tile className="bx--tile bx--tile--light">
              <h6>{`Annual drill plan documentations related to worksite ${selectedWorksite?.name} `}</h6>
              <div className="bx--col-lg-6 bx--col-md-6">  
                <FileUpload
                  Container="saipem"
                  StoragePath="drillReport"
                  onUpload={onUpload}
                  disabled={false}
                  customMainDescription="Upload in this section the worksite documentation" 
                />
              </div>
            </Tile>
            <Tile className="bx--tile bx--tile--light">
              <div className="bx--col-lg-12 bx--col-md-12">
                <TableContainer className="bx--grid--full-width">
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader>Name</TableHeader>
                        <TableHeader>Size</TableHeader>
                        <TableHeader className="align-center">Actions</TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {!worksiteAttachments || !worksiteAttachments.length ? (
                        <NoRecordsPlaceholder
                          labelText="No Records"
                          title="&#9888; It is forbidden to upload photos wich show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people"
                          colSpan={3} 
                        />
                        ) : (
                            worksiteAttachments.map((item) => (
                              <TableRow
                                key={`row_${item.idAttachment}`}
                                title="&#9888; It is forbidden to upload photos wich show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people"
                              >
                                <TableCell key={`cell_1_${item.idAttachment}`}>{item.attachment?.name}</TableCell>
                                <TableCell key={`cell_2_${item.idAttachment}`}>
                                  {sizeFormat(item.attachment?.size)}
                                </TableCell>
                                <TableCell key={`action-${item.idAttachment}`} className="tableActions align-center">
                                  {downloadingItemId === item.idAttachment ? (
                                    <div>
                                      <InlineLoading
                                        description=""
                                        iconDescription="downloading.."
                                        status="active" 
                                      />
                                    </div>
                                    ) : (
                                      <div>
                                        <Online>
                                          <DownLoadButton
                                            onError={(error) => {
                                                showNotification.error(
                                                    `${entitiesLabels.ERROR}`,
                                                    getError(error, 
                                                        entitiesLabels.FileUpload, apioperation.GET)
                                                );
                                            }}
                                            onDownLoadStart={() => 
                                              setDownlodingItemId(item.idAttachment)}
                                            onDownLoadEnd={() => setDownlodingItemId(null)}
                                            apiUrl={`/drill/${selectedWorksite?.id}/drillplanbyworksiteattachment/${item?.attachment?.fileIdentifier}`}
                                            fileName={item?.attachment?.name}
                                            size="small"
                                            renderIcon={View16}
                                            iconDescription="Download"
                                            kind="ghost"
                                            disabled={false}
                                          />
                                        </Online>
                                        <Offline>
                                          <Button
                                            size="small"
                                            renderIcon={View16}
                                            iconDescription="Download"
                                            kind="ghost"
                                            disabled 
                                          />
                                        </Offline>
                                        <Online>
                                          <Button
                                            onClick={() => 
                                                showDeleteAttachmentModal(item.idAttachment)}
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="Delete"
                                            kind="ghost"
                                            disabled={false}
                                          />
                                        </Online>
                                        <Offline>
                                          <Button
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="Delete"
                                            kind="ghost"
                                            disabled 
                                          />
                                        </Offline>
                                      </div>
                                    )
                                }
                                </TableCell>
                              </TableRow>
                            ))
                            )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Tile>
          </div>
        </ModalBody>
      </ComposedModal>
    );
};

EDrillWorkSiteAttachmentModal.propTypes = {
  onCloseWorkSiteAttachmentModal: PropTypes.func.isRequired,
  showWorkSiteAttachmentModal: PropTypes.bool.isRequired,
  selectedWorksite: PropTypes.shape({
    asset: PropTypes.bool,
    assetPortfolio: PropTypes.bool,
    code: PropTypes.string,
    createdBy: PropTypes.string,
    createdOn: PropTypes.string,
    division: PropTypes.string,
    end: PropTypes.string,
    group: PropTypes.string,
    id: PropTypes.string,
    idDivision: PropTypes.string,
    idWorkSiteGroup: PropTypes.string,
    inUse: PropTypes.bool,
    isEnabledForEnvironment: PropTypes.bool,
    isOffshore: PropTypes.bool,
    isSaipem: PropTypes.bool,
    name: PropTypes.string,
    start: PropTypes.string,
    updatedBy: PropTypes.string,
    updatedOn: PropTypes.string,
    workSiteProjects: PropTypes.array
  }),
  initialWorksiteAttachment: PropTypes.arrayOf(PropTypes.shape({
    idWorkSite: PropTypes.string,
    idAttachment: PropTypes.string,
    workSite: PropTypes.object,
    attachment: PropTypes.object
  }))
};

EDrillWorkSiteAttachmentModal.defaultProps = {
  selectedWorksite: null,
  initialWorksiteAttachment: null
};

export default EDrillWorkSiteAttachmentModal;
